/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig"; // Asegúrate de importar correctamente tu instancia de Axios.
import { calculateAge, formatDate, formatMoney } from "../utils/utils";
import GdTable from "./components/GdTable";
import { useNavigate } from "react-router-dom";
import BitacoraPacienteModal from "./BitacoraPacienteModal";
import ModalRecordatoriosPaciente from "./components/ModalRecordatoriosPaciente";


const DetallePaciente = ({ isOpen, onClose, details }) => {
    const columns2 = [
        { name: "idAcuerdo", title: "ID" },
        { name: 'fechaInicio', title: 'Fecha Inicio', render: (row) => formatDate(row.fechaInicio) },
        { name: 'horaInicio', title: 'Hora inicio' },
        { name: 'horaFin', title: 'Hora fin' },
        { name: 'nombre_auxiliar', title: 'Nombre auxiliar' },
        { name: 'apellido_paterno_auxiliar', title: 'Apellido paterno auxiliar' },
        { name: 'apellido_materno_auxiliar', title: 'Apellido materno auxiliar' },
        { name: 'rut_auxiliar', title: 'RUT auxiliar' }
    ]
    if (!isOpen) return null;
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <h3>Historial de acuerdos mutuos</h3>
                        {details ? (
                            <GdTable
                                columns={columns2}
                                data={details}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[0, "asc"]}
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const BitacoraModal = ({ isOpen, onClose, pacienteID }) => {
    if (!isOpen) return null;
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <h3>Bitacora Paciente</h3>
                        <BitacoraPacienteModal
                            pacienteId={pacienteID}
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RetirarPaciente = ({ isOpen, onClose, onConfirm, paciente }) => {
    const [motivo, setMotivo] = useState("");
    const [fechaRetiro, setFechaRetiro] = useState(new Date().toISOString().split('T')[0]);
    const [observacion, setObservacion] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [turno, setTurno] = useState('noche'); // 'dia' o 'noche'

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!motivo) {
            gdAlertify.notiError("Por favor seleccione un motivo");
            return;
        }

        setIsSubmitting(true);

        try {
            const retiroData = {
                pacienteId: paciente.id,
                motivo,
                fechaRetiro,
                observacion,
                turno
            };

            // Reemplaza con tu endpoint correcto
            await axiosInstance.post('/paciente/retirar', retiroData);

            // onConfirm(window.location.reload()); // Puedes pasar los datos al callback si es necesario
            onClose(); // Cierra el modal después del éxito

            // Resetear el formulario
            setMotivo("");
            setFechaRetiro(new Date().toISOString().split('T')[0]);
            setObservacion("");
            gdAlertify.alertSuccess("Paciente Retirado.");
        } catch (error) {
            console.error("Error al retirar paciente:", error);
            gdAlertify.notiError("Ocurrió un error al retirar al paciente.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const onCloseRetiro = () => {
        onClose();
        setMotivo("");
        setFechaRetiro(new Date().toISOString().split('T')[0]);
        setObservacion("");
    };

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="retirarPacienteModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Retirar Paciente</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>¿Estás seguro de que deseas retirar al paciente <strong>{paciente?.nombres} {paciente?.apellidoPaterno}</strong>?</p>

                        <div className="mb-3">
                            <label className="form-label">Motivo del retiro:</label>
                            <select
                                className="form-select"
                                value={motivo}
                                onChange={(e) => setMotivo(e.target.value)}
                                required
                            >
                                <option value="">Seleccione un motivo</option>
                                <option value="Alta médica">Alta médica</option>
                                <option value="Fallecimiento">Fallecimiento</option>
                                <option value="Traslado">Traslado</option>
                                <option value="Otro">Otro</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Fecha de retiro:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaRetiro}
                                onChange={(e) => setFechaRetiro(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="turnoSelect" className="form-label">Periodo</label>
                            <select
                                id="turnoSelect"
                                className="form-select"
                                value={turno}
                                onChange={(e) => setTurno(e.target.value)}
                            >
                                <option value="dia">Día</option>
                                <option value="noche">Noche</option>
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Observación (opcional):</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={observacion}
                                onChange={(e) => setObservacion(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onCloseRetiro}
                            disabled={isSubmitting}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Enviando...' : 'Confirmar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const NominaPaciente = () => {
    const [resultados, setResultados] = useState([]); // Estado para almacenar los Paciente obtenidos.
    const [selectedPaciente, setSelectedPaciente] = useState(null);
    const [history, setHistory] = useState({}); // Estado para almacenar los historiales de los Paciente.
    const [bitacoraPaciente, setBitacoraPaciente] = useState(false);
    const [pacienteSeleccionadoId, setPacienteSeleccionadoId] = useState(null);
    // Estados para el modal de recordatorios
    const [pacienteRecordatorio, setPacienteRecordatorio] = useState(null);
    const [isRecordatoriosOpen, setIsRecordatoriosOpen] = useState(false);

    const [verRetirados, setVerRetirados] = useState(false);

    useEffect(() => {
        gdAlertify.showLoader()
        async function buscarPaciente() {
            try {
                const params = { retirados: verRetirados ? 1 : 0 };

                // Realiza la llamada a la API para obtener los Paciente.
                const response = await axiosInstance.get("/paciente/busqueda", { params });
                setResultados(response.data.data); // Almacena los resultados en el estado.
                gdAlertify.hideLoader()
            } catch (error) {
                gdAlertify.hideLoader()
                console.error("Error al buscar Paciente: ", error);
            }
        };

        buscarPaciente();
    }, [verRetirados]);

    const handleViewHistory = async (PacienteID) => {
        try {
            // Llamada a la API para obtener el historial de un Paciente específico.
            const response = await axiosInstance.get(`/Paciente/${PacienteID}/historial`);
            setHistory((prev) => ({ ...prev, [PacienteID]: response.data.data }));
            setSelectedPaciente(PacienteID);
        } catch (error) {
            console.error("Error al obtener el historial del Paciente: ", error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalRetiroOpen, setIsModalRetiroOpen] = useState(false);
    const [detallePaciente, setDetallePaciente] = useState(null);

    const verHistorial = async (idPaciente) => {
        setIsModalOpen(true); // Abre el modal
        setDetallePaciente(null); // Limpia los datos previos mientras carga

        const params = {
            idPaciente: idPaciente
        };

        try {
            const response = await axiosInstance.get("/paciente/historial", { params });
            setDetallePaciente(response.data.data);
        } catch (error) {
            console.error(error);
            setDetallePaciente({ error: "No se pudo cargar la información" });
        }
    };

    const retirarPaciente = async (idPaciente) => {
        setIsModalRetiroOpen(true);
        setDetallePaciente({ id: idPaciente });
    };

    const activarPaciente = (pacienteId) => {
        gdAlertify.confirm({
            title: "Activar Paciente",
            message: "¿Está seguro que desea activar nuevamente a este paciente?",
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const response = await axiosInstance.post("/paciente/activar", { pacienteId });
                    if (!response.data.error) {
                        gdAlertify.alertSuccess(response.data.message || "Paciente activado correctamente");
                        // Refrescar lista manualmente con la url de busqueda
                        try {
                            const params = { retirados: verRetirados ? 1 : 0 };
                            const res = await axiosInstance.get("/paciente/busqueda", { params });
                            setResultados(res.data.data);
                        } catch(e) {}
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                } catch (error) {
                    console.error("Error al activar paciente:", error);
                    gdAlertify.notiError("Ocurrió un error al activar al paciente.");
                } finally {
                    gdAlertify.hideLoader();
                }
            }
        });
    };

    const navigate = useNavigate();
    const editarPaciente = (idPaciente) => {
        navigate(`/editar-paciente/${idPaciente}`);
    };

    const abrirRecordatorios = (paciente) => {
        setPacienteRecordatorio(paciente);
        setIsRecordatoriosOpen(true);
    };

    const columns = [
        {
            name: "id",
            title: "Acción",
            width: 100,
            render: (row) => {
                return (
                    <div className="dropdown">
                        <button
                            className="btn btn-sm btn-primary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Acciones
                        </button>
                        <ul className="dropdown-menu">
                            {/* Editar */}
                            <li>
                                <button
                                    className="dropdown-item text-success"
                                    onClick={() => editarPaciente(row.id)}
                                >
                                    <i className="bi bi-pencil-square me-2"></i>
                                    Editar
                                </button>
                            </li>

                            {/* Ver Ingresos */}
                            <li>
                                <button
                                    className="dropdown-item text-primary"
                                    onClick={() => {
                                        setPacienteSeleccionadoId(row.id);
                                        setBitacoraPaciente(true);
                                    }}
                                >
                                    <i className="bi bi-journal-text me-2"></i>
                                    Ver Ingresos
                                </button>
                            </li>

                            {/* Ver Historial */}
                            <li>
                                <button
                                    className="dropdown-item text-secondary"
                                    onClick={() => verHistorial(row.id)}
                                >
                                    <i className="bi bi-clock-history me-2"></i>
                                    Ver Historial
                                </button>
                            </li>

                            {/* Recordatorios */}
                            <li>
                                <button
                                    className="dropdown-item text-info"
                                    onClick={() => abrirRecordatorios(row)}
                                >
                                    <i className="bi bi-bell me-2"></i>
                                    Recordatorios
                                </button>
                            </li>

                            {/* Retirar */}
                            {row.estado !== 0 && (
                                <li>
                                    <button
                                        className="dropdown-item text-danger"
                                        onClick={() => retirarPaciente(row.id)}
                                    >
                                        <i className="bi bi-person-x me-2"></i>
                                        Retirar
                                    </button>
                                </li>
                            )}

                            {/* Activar */}
                            {row.estado === 0 && (
                                <li>
                                    <button
                                        className="dropdown-item text-primary"
                                        onClick={() => activarPaciente(row.id)}
                                    >
                                        <i className="bi bi-person-check me-2"></i>
                                        Activar
                                    </button>
                                </li>
                            )}
                        </ul>
                    </div>
                );
            },
        },
        {
            name: "nombrePaciente",
            title: "Nombre y Apellidos",
            headerClassName: "mw-200",
            cellClassName: "mw-200",
        },
        {
            name: "rut",
            title: "Rut",
        },
        { name: 'fechaNacimiento', title: 'Edad', render: (row) => calculateAge(row.fechaNacimiento) },
        { name: "direccion", title: "Direccion" },
        { name: "como_llegar", title: "Como llegar" },
        { name: "desc_comuna", title: "Comuna" },
        {
            name: 'des_turno',
            title: 'Tipo Turno',
            headerClassName: "mw-200",
            cellClassName: "mw-200",
            render: (row) => {
                return row.turnos ? row.turnos.rotation_pattern_text || '-' : '-';
            }
        },
        {
            name: 'des_turno',
            title: 'Rotación',
            headerClassName: "mw-200",
            cellClassName: "mw-200",
            render: (row) => {
                return row.turnos ? row.turnos.rotation_pattern_text2 || '-' : '-';
            }
        },
        {
            name: 'horaInicio',
            title: 'Hora de Inicio',
            render: (row) => {
                return row.turnos ? row.turnos.hora_inicio || '-' : '-';
            }
        },
        {
            name: 'horaFin',
            title: 'Hora de Fin',
            render: (row) => {
                return row.turnos ? row.turnos.hora_fin || '-' : '-';
            }
        },
        { name: "diagnostico", title: "Diagnostico" },
        { name: "fecha_ultima_atencion", title: "Fecha de ultima visita" },
        { name: "valorTurnoPaciente", title: "Valor por turno", render: (row) => '$' + formatMoney(row.valorTurnoAuxiliar) },
        { name: "valorLocomocionPaciente", title: "Locomocion", render: (row) => '$' + formatMoney(row.valorLocomocionAuxiliar) },
        { name: "valorColacionPaciente", title: "Colacion", render: (row) => '$' + formatMoney(row.valorColacionAuxiliar) },
        {
            name: "estado",
            title: "Estado",
            render: (row) => {
                if (row.estado === 1) {
                    return <span className="text-success">Activo</span>;
                } else {
                    return (
                        <div className="text-danger">
                            <div><strong>Motivo:</strong> {row.motivo_retiro || '-'}</div>
                            <div><strong>Fecha:</strong> {formatDate(row.fecha_retiro) || '-'}</div>
                            <div><strong>Obs.:</strong> {row.observacion || '-'}</div>
                        </div>
                    );
                }
            }
        },

    ]

    return (
        <div className="container-fluid mt-5">
            <div className="card p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">Listado de Pacientes</h3>
                    <div className="form-check form-switch pt-2">
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            id="checkVerRetirados" 
                            checked={verRetirados} 
                            onChange={(e) => setVerRetirados(e.target.checked)} 
                        />
                        <label className="form-check-label fw-bold" htmlFor="checkVerRetirados">Ver retirados (No fallecidos)</label>
                    </div>
                </div>
                {/* Tabla principal */}
                <GdTable
                    columns={columns}
                    data={resultados}
                    defaultItemsPerPage={100}
                    itemsPerPageOptions={[5, 10, 25, 50, 100]}
                    initialSort={[1, "asc"]}
                />
            </div>
            {/* Modal */}
            <DetallePaciente
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                details={detallePaciente}
            />

            {bitacoraPaciente && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <BitacoraPacienteModal
                        pacienteId={pacienteSeleccionadoId}
                        onClose={() => setBitacoraPaciente(false)}
                    />
                </div>
            )}

            <RetirarPaciente
                isOpen={isModalRetiroOpen}
                onClose={() => setIsModalRetiroOpen(false)}
                paciente={detallePaciente}
            />

            <ModalRecordatoriosPaciente
                isOpen={isRecordatoriosOpen}
                onClose={() => setIsRecordatoriosOpen(false)}
                pacienteId={pacienteRecordatorio?.id}
                pacienteNombre={pacienteRecordatorio ? `${pacienteRecordatorio.nombres} ${pacienteRecordatorio.apellidoPaterno}` : ""}
            />

        </div>
    );
};

export default NominaPaciente;